/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShellRouteRouteImport } from './routes/_shell/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardSplatRouteImport } from './routes/dashboard/$'
import { Route as ShellVoxsenseIndexRouteImport } from './routes/_shell/voxsense/index'
import { Route as ShellVoxlaneIndexRouteImport } from './routes/_shell/voxlane/index'
import { Route as ShellSiftIndexRouteImport } from './routes/_shell/sift/index'
import { Route as ShellHomeIndexRouteImport } from './routes/_shell/home/index'
import { Route as ShellBillingIndexRouteImport } from './routes/_shell/billing/index'
import { Route as ShellVoxsenseRoutingIndexRouteImport } from './routes/_shell/voxsense/routing/index'
import { Route as ShellVoxsenseCallsIndexRouteImport } from './routes/_shell/voxsense/calls/index'
import { Route as ShellVoxlaneLanesIndexRouteImport } from './routes/_shell/voxlane/lanes/index'
import { Route as ShellVoxlaneBillingIndexRouteImport } from './routes/_shell/voxlane/billing/index'
import { Route as ShellSiftUsageIndexRouteImport } from './routes/_shell/sift/usage/index'
import { Route as ShellSiftListsIndexRouteImport } from './routes/_shell/sift/lists/index'
import { Route as ShellVoxsenseCallsCallIdRouteImport } from './routes/_shell/voxsense/calls/$callId'
import { Route as ShellVoxlaneLanesNewRouteImport } from './routes/_shell/voxlane/lanes/new'
import { Route as ShellVoxlaneLanesIdRouteImport } from './routes/_shell/voxlane/lanes/$id'
import { Route as ShellSiftListsIdRouteImport } from './routes/_shell/sift/lists/$id'
import { Route as ShellBillingDocumentsIdRouteImport } from './routes/_shell/billing/documents/$id'

const ShellRouteRoute = ShellRouteRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSplatRoute = DashboardSplatRouteImport.update({
  id: '/dashboard/$',
  path: '/dashboard/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellVoxsenseIndexRoute = ShellVoxsenseIndexRouteImport.update({
  id: '/voxsense/',
  path: '/voxsense/',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellVoxlaneIndexRoute = ShellVoxlaneIndexRouteImport.update({
  id: '/voxlane/',
  path: '/voxlane/',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellSiftIndexRoute = ShellSiftIndexRouteImport.update({
  id: '/sift/',
  path: '/sift/',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellHomeIndexRoute = ShellHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellBillingIndexRoute = ShellBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellVoxsenseRoutingIndexRoute =
  ShellVoxsenseRoutingIndexRouteImport.update({
    id: '/voxsense/routing/',
    path: '/voxsense/routing/',
    getParentRoute: () => ShellRouteRoute,
  } as any)
const ShellVoxsenseCallsIndexRoute = ShellVoxsenseCallsIndexRouteImport.update({
  id: '/voxsense/calls/',
  path: '/voxsense/calls/',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellVoxlaneLanesIndexRoute = ShellVoxlaneLanesIndexRouteImport.update({
  id: '/voxlane/lanes/',
  path: '/voxlane/lanes/',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellVoxlaneBillingIndexRoute =
  ShellVoxlaneBillingIndexRouteImport.update({
    id: '/voxlane/billing/',
    path: '/voxlane/billing/',
    getParentRoute: () => ShellRouteRoute,
  } as any)
const ShellSiftUsageIndexRoute = ShellSiftUsageIndexRouteImport.update({
  id: '/sift/usage/',
  path: '/sift/usage/',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellSiftListsIndexRoute = ShellSiftListsIndexRouteImport.update({
  id: '/sift/lists/',
  path: '/sift/lists/',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellVoxsenseCallsCallIdRoute =
  ShellVoxsenseCallsCallIdRouteImport.update({
    id: '/voxsense/calls/$callId',
    path: '/voxsense/calls/$callId',
    getParentRoute: () => ShellRouteRoute,
  } as any)
const ShellVoxlaneLanesNewRoute = ShellVoxlaneLanesNewRouteImport.update({
  id: '/voxlane/lanes/new',
  path: '/voxlane/lanes/new',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellVoxlaneLanesIdRoute = ShellVoxlaneLanesIdRouteImport.update({
  id: '/voxlane/lanes/$id',
  path: '/voxlane/lanes/$id',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellSiftListsIdRoute = ShellSiftListsIdRouteImport.update({
  id: '/sift/lists/$id',
  path: '/sift/lists/$id',
  getParentRoute: () => ShellRouteRoute,
} as any)
const ShellBillingDocumentsIdRoute = ShellBillingDocumentsIdRouteImport.update({
  id: '/billing/documents/$id',
  path: '/billing/documents/$id',
  getParentRoute: () => ShellRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/billing/': typeof ShellBillingIndexRoute
  '/home/': typeof ShellHomeIndexRoute
  '/sift/': typeof ShellSiftIndexRoute
  '/voxlane/': typeof ShellVoxlaneIndexRoute
  '/voxsense/': typeof ShellVoxsenseIndexRoute
  '/billing/documents/$id': typeof ShellBillingDocumentsIdRoute
  '/sift/lists/$id': typeof ShellSiftListsIdRoute
  '/voxlane/lanes/$id': typeof ShellVoxlaneLanesIdRoute
  '/voxlane/lanes/new': typeof ShellVoxlaneLanesNewRoute
  '/voxsense/calls/$callId': typeof ShellVoxsenseCallsCallIdRoute
  '/sift/lists/': typeof ShellSiftListsIndexRoute
  '/sift/usage/': typeof ShellSiftUsageIndexRoute
  '/voxlane/billing/': typeof ShellVoxlaneBillingIndexRoute
  '/voxlane/lanes/': typeof ShellVoxlaneLanesIndexRoute
  '/voxsense/calls/': typeof ShellVoxsenseCallsIndexRoute
  '/voxsense/routing/': typeof ShellVoxsenseRoutingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/dashboard': typeof DashboardIndexRoute
  '/login': typeof LoginIndexRoute
  '/billing': typeof ShellBillingIndexRoute
  '/home': typeof ShellHomeIndexRoute
  '/sift': typeof ShellSiftIndexRoute
  '/voxlane': typeof ShellVoxlaneIndexRoute
  '/voxsense': typeof ShellVoxsenseIndexRoute
  '/billing/documents/$id': typeof ShellBillingDocumentsIdRoute
  '/sift/lists/$id': typeof ShellSiftListsIdRoute
  '/voxlane/lanes/$id': typeof ShellVoxlaneLanesIdRoute
  '/voxlane/lanes/new': typeof ShellVoxlaneLanesNewRoute
  '/voxsense/calls/$callId': typeof ShellVoxsenseCallsCallIdRoute
  '/sift/lists': typeof ShellSiftListsIndexRoute
  '/sift/usage': typeof ShellSiftUsageIndexRoute
  '/voxlane/billing': typeof ShellVoxlaneBillingIndexRoute
  '/voxlane/lanes': typeof ShellVoxlaneLanesIndexRoute
  '/voxsense/calls': typeof ShellVoxsenseCallsIndexRoute
  '/voxsense/routing': typeof ShellVoxsenseRoutingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_shell': typeof ShellRouteRouteWithChildren
  '/dashboard/$': typeof DashboardSplatRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_shell/billing/': typeof ShellBillingIndexRoute
  '/_shell/home/': typeof ShellHomeIndexRoute
  '/_shell/sift/': typeof ShellSiftIndexRoute
  '/_shell/voxlane/': typeof ShellVoxlaneIndexRoute
  '/_shell/voxsense/': typeof ShellVoxsenseIndexRoute
  '/_shell/billing/documents/$id': typeof ShellBillingDocumentsIdRoute
  '/_shell/sift/lists/$id': typeof ShellSiftListsIdRoute
  '/_shell/voxlane/lanes/$id': typeof ShellVoxlaneLanesIdRoute
  '/_shell/voxlane/lanes/new': typeof ShellVoxlaneLanesNewRoute
  '/_shell/voxsense/calls/$callId': typeof ShellVoxsenseCallsCallIdRoute
  '/_shell/sift/lists/': typeof ShellSiftListsIndexRoute
  '/_shell/sift/usage/': typeof ShellSiftUsageIndexRoute
  '/_shell/voxlane/billing/': typeof ShellVoxlaneBillingIndexRoute
  '/_shell/voxlane/lanes/': typeof ShellVoxlaneLanesIndexRoute
  '/_shell/voxsense/calls/': typeof ShellVoxsenseCallsIndexRoute
  '/_shell/voxsense/routing/': typeof ShellVoxsenseRoutingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard/$'
    | '/dashboard/'
    | '/login/'
    | '/billing/'
    | '/home/'
    | '/sift/'
    | '/voxlane/'
    | '/voxsense/'
    | '/billing/documents/$id'
    | '/sift/lists/$id'
    | '/voxlane/lanes/$id'
    | '/voxlane/lanes/new'
    | '/voxsense/calls/$callId'
    | '/sift/lists/'
    | '/sift/usage/'
    | '/voxlane/billing/'
    | '/voxlane/lanes/'
    | '/voxsense/calls/'
    | '/voxsense/routing/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard/$'
    | '/dashboard'
    | '/login'
    | '/billing'
    | '/home'
    | '/sift'
    | '/voxlane'
    | '/voxsense'
    | '/billing/documents/$id'
    | '/sift/lists/$id'
    | '/voxlane/lanes/$id'
    | '/voxlane/lanes/new'
    | '/voxsense/calls/$callId'
    | '/sift/lists'
    | '/sift/usage'
    | '/voxlane/billing'
    | '/voxlane/lanes'
    | '/voxsense/calls'
    | '/voxsense/routing'
  id:
    | '__root__'
    | '/'
    | '/_shell'
    | '/dashboard/$'
    | '/dashboard/'
    | '/login/'
    | '/_shell/billing/'
    | '/_shell/home/'
    | '/_shell/sift/'
    | '/_shell/voxlane/'
    | '/_shell/voxsense/'
    | '/_shell/billing/documents/$id'
    | '/_shell/sift/lists/$id'
    | '/_shell/voxlane/lanes/$id'
    | '/_shell/voxlane/lanes/new'
    | '/_shell/voxsense/calls/$callId'
    | '/_shell/sift/lists/'
    | '/_shell/sift/usage/'
    | '/_shell/voxlane/billing/'
    | '/_shell/voxlane/lanes/'
    | '/_shell/voxsense/calls/'
    | '/_shell/voxsense/routing/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ShellRouteRoute: typeof ShellRouteRouteWithChildren
  DashboardSplatRoute: typeof DashboardSplatRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/$': {
      id: '/dashboard/$'
      path: '/dashboard/$'
      fullPath: '/dashboard/$'
      preLoaderRoute: typeof DashboardSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/voxsense/': {
      id: '/_shell/voxsense/'
      path: '/voxsense'
      fullPath: '/voxsense/'
      preLoaderRoute: typeof ShellVoxsenseIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/voxlane/': {
      id: '/_shell/voxlane/'
      path: '/voxlane'
      fullPath: '/voxlane/'
      preLoaderRoute: typeof ShellVoxlaneIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/sift/': {
      id: '/_shell/sift/'
      path: '/sift'
      fullPath: '/sift/'
      preLoaderRoute: typeof ShellSiftIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/home/': {
      id: '/_shell/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof ShellHomeIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/billing/': {
      id: '/_shell/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof ShellBillingIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/voxsense/routing/': {
      id: '/_shell/voxsense/routing/'
      path: '/voxsense/routing'
      fullPath: '/voxsense/routing/'
      preLoaderRoute: typeof ShellVoxsenseRoutingIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/voxsense/calls/': {
      id: '/_shell/voxsense/calls/'
      path: '/voxsense/calls'
      fullPath: '/voxsense/calls/'
      preLoaderRoute: typeof ShellVoxsenseCallsIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/voxlane/lanes/': {
      id: '/_shell/voxlane/lanes/'
      path: '/voxlane/lanes'
      fullPath: '/voxlane/lanes/'
      preLoaderRoute: typeof ShellVoxlaneLanesIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/voxlane/billing/': {
      id: '/_shell/voxlane/billing/'
      path: '/voxlane/billing'
      fullPath: '/voxlane/billing/'
      preLoaderRoute: typeof ShellVoxlaneBillingIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/sift/usage/': {
      id: '/_shell/sift/usage/'
      path: '/sift/usage'
      fullPath: '/sift/usage/'
      preLoaderRoute: typeof ShellSiftUsageIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/sift/lists/': {
      id: '/_shell/sift/lists/'
      path: '/sift/lists'
      fullPath: '/sift/lists/'
      preLoaderRoute: typeof ShellSiftListsIndexRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/voxsense/calls/$callId': {
      id: '/_shell/voxsense/calls/$callId'
      path: '/voxsense/calls/$callId'
      fullPath: '/voxsense/calls/$callId'
      preLoaderRoute: typeof ShellVoxsenseCallsCallIdRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/voxlane/lanes/new': {
      id: '/_shell/voxlane/lanes/new'
      path: '/voxlane/lanes/new'
      fullPath: '/voxlane/lanes/new'
      preLoaderRoute: typeof ShellVoxlaneLanesNewRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/voxlane/lanes/$id': {
      id: '/_shell/voxlane/lanes/$id'
      path: '/voxlane/lanes/$id'
      fullPath: '/voxlane/lanes/$id'
      preLoaderRoute: typeof ShellVoxlaneLanesIdRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/sift/lists/$id': {
      id: '/_shell/sift/lists/$id'
      path: '/sift/lists/$id'
      fullPath: '/sift/lists/$id'
      preLoaderRoute: typeof ShellSiftListsIdRouteImport
      parentRoute: typeof ShellRouteRoute
    }
    '/_shell/billing/documents/$id': {
      id: '/_shell/billing/documents/$id'
      path: '/billing/documents/$id'
      fullPath: '/billing/documents/$id'
      preLoaderRoute: typeof ShellBillingDocumentsIdRouteImport
      parentRoute: typeof ShellRouteRoute
    }
  }
}

interface ShellRouteRouteChildren {
  ShellBillingIndexRoute: typeof ShellBillingIndexRoute
  ShellHomeIndexRoute: typeof ShellHomeIndexRoute
  ShellSiftIndexRoute: typeof ShellSiftIndexRoute
  ShellVoxlaneIndexRoute: typeof ShellVoxlaneIndexRoute
  ShellVoxsenseIndexRoute: typeof ShellVoxsenseIndexRoute
  ShellBillingDocumentsIdRoute: typeof ShellBillingDocumentsIdRoute
  ShellSiftListsIdRoute: typeof ShellSiftListsIdRoute
  ShellVoxlaneLanesIdRoute: typeof ShellVoxlaneLanesIdRoute
  ShellVoxlaneLanesNewRoute: typeof ShellVoxlaneLanesNewRoute
  ShellVoxsenseCallsCallIdRoute: typeof ShellVoxsenseCallsCallIdRoute
  ShellSiftListsIndexRoute: typeof ShellSiftListsIndexRoute
  ShellSiftUsageIndexRoute: typeof ShellSiftUsageIndexRoute
  ShellVoxlaneBillingIndexRoute: typeof ShellVoxlaneBillingIndexRoute
  ShellVoxlaneLanesIndexRoute: typeof ShellVoxlaneLanesIndexRoute
  ShellVoxsenseCallsIndexRoute: typeof ShellVoxsenseCallsIndexRoute
  ShellVoxsenseRoutingIndexRoute: typeof ShellVoxsenseRoutingIndexRoute
}

const ShellRouteRouteChildren: ShellRouteRouteChildren = {
  ShellBillingIndexRoute: ShellBillingIndexRoute,
  ShellHomeIndexRoute: ShellHomeIndexRoute,
  ShellSiftIndexRoute: ShellSiftIndexRoute,
  ShellVoxlaneIndexRoute: ShellVoxlaneIndexRoute,
  ShellVoxsenseIndexRoute: ShellVoxsenseIndexRoute,
  ShellBillingDocumentsIdRoute: ShellBillingDocumentsIdRoute,
  ShellSiftListsIdRoute: ShellSiftListsIdRoute,
  ShellVoxlaneLanesIdRoute: ShellVoxlaneLanesIdRoute,
  ShellVoxlaneLanesNewRoute: ShellVoxlaneLanesNewRoute,
  ShellVoxsenseCallsCallIdRoute: ShellVoxsenseCallsCallIdRoute,
  ShellSiftListsIndexRoute: ShellSiftListsIndexRoute,
  ShellSiftUsageIndexRoute: ShellSiftUsageIndexRoute,
  ShellVoxlaneBillingIndexRoute: ShellVoxlaneBillingIndexRoute,
  ShellVoxlaneLanesIndexRoute: ShellVoxlaneLanesIndexRoute,
  ShellVoxsenseCallsIndexRoute: ShellVoxsenseCallsIndexRoute,
  ShellVoxsenseRoutingIndexRoute: ShellVoxsenseRoutingIndexRoute,
}

const ShellRouteRouteWithChildren = ShellRouteRoute._addFileChildren(
  ShellRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ShellRouteRoute: ShellRouteRouteWithChildren,
  DashboardSplatRoute: DashboardSplatRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
